import { QueryConstraint, Timestamp, Unsubscribe, where } from "firebase/firestore";
import FirestorePipe from "../utils/pipe";
import EverestLog from "../entities/everestLog";

class EverestLogDB extends FirestorePipe {
    public static readonly colName = 'LogEverest';

    constructor() {
        super(EverestLogDB.colName);
    }

    public create(data: EverestLog): Promise<string> {
        return this._create<EverestLog>(data);
    }

    public update(id: string, data: Partial<EverestLog>): Promise<void> {
        return this._update<Partial<EverestLog>>(id, data);
    }

    public delete(id: string): Promise<void> {
        return this._delete(id);
    }

    public getAll(...params: QueryConstraint[]): Promise<EverestLog[]> {
        return this._getAll<EverestLog>(...params);
    }

    public get(id: string): Promise<EverestLog> {
        return this._get<EverestLog>(id);
    }

    public on(listener: (data: EverestLog[]) => void, ...params: QueryConstraint[]): Unsubscribe {
        return this._on<EverestLog>(listener, ...params);
    }
}

export default EverestLogDB;